import ContentSections from "../../ContentSections/ContentSections";
import ImagePickerField from "../../Admin/ImagePickerField/ImagePickerField";
import { getImageUrl } from "../../../utils/media";

const FALLBACK_TEXTO = "";

const FALLBACK_SECTION = {
  title: "Educação Integral",
  text: "",
};

export default function Intro({ text, section, isEditing, onChange, onSectionChange }) {
  const sectionValue = section ?? FALLBACK_SECTION;
  const imageUrl = getImageUrl(sectionValue.image);

  if(isEditing) {
    return (
      <div className="metodologia-page__bloco">
        <div className="metodologia-page__bloco-item">
          <textarea
            className="metodologia-page__campo"
            value={text || ""}
            onChange={(e) => onChange(e.target.value)}
          />
        </div>
        <div className="metodologia-page__bloco-item">
          <input
            className="metodologia-page__campo"
            value={sectionValue.title || ""}
            onChange={(e) => onSectionChange("title", e.target.value)}
          />
          <textarea
            className="metodologia-page__campo"
            value={sectionValue.text || ""}
            onChange={(e) => onSectionChange("text", e.target.value)}
          />
          <ImagePickerField
            value={sectionValue.image}
            onChange={(image) => onSectionChange("image", image)}
            alt={sectionValue.title || "Introdução da metodologia"}
          />
        </div>
      </div>
    );
  }
  return (
    <ContentSections
      className="content-sections--intro"
      sections={[
        { text: text ?? FALLBACK_TEXTO },
        {
          title: sectionValue.title,
          text: sectionValue.text,
          imageUrl,
          imageAlt: sectionValue.title || "Introdução da metodologia",
        },
      ]}
    />
  );
}
